__turbopack_context__.v({
  "discountBox": "F1ehTq_discountBox",
  "discountLabel": "F1ehTq_discountLabel",
  "discountLabelText": "F1ehTq_discountLabelText",
  "discountValue": "F1ehTq_discountValue",
  "icon": "F1ehTq_icon",
  "row": "F1ehTq_row",
});
